export default __webpack_public_path__ + "static/media/Background_00169.2edf5905.png";